import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../../widgets/widgets.module';
import { CtTextComponent } from './ct-text/ct-text.component';
import { CtDropdownComponent } from './ct-dropdown/ct-dropdown.component';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { CtAliasComponent } from './ct-alias/ct-alias.component';
// TODO: Temporarily disabled for Angular 16 migration - ngx-chips not compatible
// // TODO: Temporarily disabled - ngx-chips not compatible
// import { TagInputModule } from 'ngx-chips';
import { CtMedComponent } from './ct-med/ct-med.component';
import { CtMsdComponent } from './ct-msd/ct-msd.component';
import { CtInputComponent } from './ct-input/ct-input.component';
import { CtLabelComponent } from './ct-label/ct-label.component';
import { CtIconComponent } from './ct-icon/ct-icon.component';
import { CtSingleDropdownComponent } from './ct-single-dropdown/ct-single-dropdown.component';
import { CtTextareaComponent } from './ct-textarea/ct-textarea.component';
import { CtDateComponent } from './ct-date/ct-date.component';
import { CtDividerComponent } from './ct-divider/ct-divider.component';
import { CtComboboxComponent } from './ct-combobox/ct-combobox.component';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
        // // TagInputModule,
        // kendo
        DateInputsModule,
        DropDownsModule,
        FroalaEditorModule.forRoot(),
        FroalaViewModule.forRoot(),
        // EffectsModule.forFeature([NoteEffects]),
    ],
    declarations: [
        CtInputComponent,
        CtLabelComponent,
        CtTextComponent,
        CtDropdownComponent,
        CtAliasComponent,
        CtMedComponent,
        CtMsdComponent,
        CtIconComponent,
        CtSingleDropdownComponent,
        CtTextareaComponent,
        CtDateComponent,
        CtDividerComponent,
        CtComboboxComponent,
    ],
    exports: [
        CtInputComponent,
        CtLabelComponent,
        CtTextComponent,
        CtDropdownComponent,
        CtAliasComponent,
        CtMedComponent,
        CtMsdComponent,
        CtIconComponent,
        CtSingleDropdownComponent,
        CtTextareaComponent,
        CtDateComponent,
        CtDividerComponent,
        CtComboboxComponent,
    ]
})
export class ContactTemplateModule { }
